import { render, staticRenderFns } from "./IconAddMoreRounded.vue?vue&type=template&id=085ee120"
import script from "./IconAddMoreRounded.vue?vue&type=script&lang=js"
export * from "./IconAddMoreRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports